import { isDevModeOn } from "@base/lib/dev-toolbar/devTools";

/**
 * In-memory log behind the dev toolbar's tracking panel. Records while dev mode
 * is on (`?devmode=true`), so opening the panel shows what already happened on
 * this page load. Records nothing otherwise.
 */

const MAX_ENTRIES = 200;

export type DebugEntry = {
  id: number;
  time: number;
  /** null = one of our own events (the input); otherwise what a tracker was sent. */
  tracker: string | null;
  label: string;
  detail?: unknown;
};

let entries: DebugEntry[] = [];
let nextId = 1;
const listeners = new Set<() => void>();

export function logTrackingDebug(tracker: string | null, label: string, detail?: unknown): void {
  if (!isDevModeOn()) {
    return;
  }
  entries = [...entries.slice(-(MAX_ENTRIES - 1)), { id: nextId++, time: Date.now(), tracker, label, detail }];
  notify();
}

export function clearTrackingDebug(): void {
  entries = [];
  notify();
}

export function getTrackingDebugEntries(): DebugEntry[] {
  return entries;
}

export function subscribeTrackingDebug(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function notify() {
  listeners.forEach((listener) => listener());
}
